import React from 'react'
import { recaptchaSiteKeyV3 } from 'shared/utils'
import { ReCaptcha } from 'react-recaptcha-v3'

type Props = {
    verifyCallback: Function,
    action: string
}
const Recaptcha = React.forwardRef((props: Props, ref) => {
    return (
        <ReCaptcha
            sitekey={process.env.REACT_APP_SITE_KEY || recaptchaSiteKeyV3}
            {...props}
            ref={ref}
        />
    )
})

export { Recaptcha }
